export type TipIdsByCycle = {
    all: { id?: string; type: string; url?: string; } ;
    cycle1?: { id?: string; type: string; url?: string; } ;
    cycle3?: { id?: string; type: string; url?: string; } ;
}

export type TipIds = {
    all_targets: TipIdsByCycle,
    family?: TipIdsByCycle,
    animator?: TipIdsByCycle
}

type SectionTips = {
    grow?: TipIds;
    inspire?: TipIds;
    still?: TipIds;
    talk?: TipIds;
}

type SuperPowerTips = {

}

class Tips {
    private static instance: Tips;

    public key: string = "";
    public last_update: number = 0;

    public sections?: SectionTips = {};
    public superpowers?: SuperPowerTips = {};

    public static getInstance(): Tips {
        if (!Tips.instance) {
            Tips.instance = new Tips();
        }

        return Tips.instance;
    }
}

export default Tips;